@if (!noData && dataExists()) {
  <div (chartDataZoom)="onZoom($event)"
    (chartFinished)="onChartFinish($event)"
    (chartInit)="onChartInit()"
    (chartLegendSelectChanged)="onLegendChange($event)"
    [attr.id]="myId"
    [initOpts]="initOpts"
    [ngClass]="{'opacity-0' : isLoading || noData, 'opacity-1' : !isLoading}"
    [ngStyle]="{'min-height.px' : minHeight}"
    [options]="chartOption"
    class="chart-main-class"
    echarts>
  </div>
} @else {
  <div class="no-chart-data d-flex align-items-center justify-content-center h-100">
    {{ "healthPlan.noData" | translate }}
  </div>
}

@if (isLoading) {
  <div [ngClass]="{'opacity-0' : !isLoading, 'opacity-1' :isLoading}"
    class="chart-loading-spinner">
    <mat-spinner></mat-spinner>
  </div>
}

